export const DEFAULT_GOOGLE_RECAPTCHA_GLOBAL_NAME = "grecaptcha";
export const DEFAULT_CASTLE_GLOBAL_NAME = "Castle";

export const CASTLE_URL = "https://unpkg.com/@castleio/castle-js@latest/dist/castle.browser.js";
export const getGoogleRecaptchaUrl = siteKey =>
	`https://www.google.com/recaptcha/api.js?render=${siteKey}`;
